import { FifoCache } from './fifo-cache.cls';
/**
 *
 */
export const NSCaches = {
    FifoCache
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/cache/index.ts
// module id = null
// module chunks = 